import React, { Component } from 'react';

import './ResponseMetaInfo.css';

import { updateCondition, createCondition, deleteCondition } from './ResponseMetaInfoAPI';

// Icon
import RedirectIcon from '../../Icons/RedirectIcon';
import redirectIconSVG from '../../images/redirect-icon.svg';
import conditionIconSVG from '../../images/condition-icon.svg';

// Components
import ResponseConditions from './ResponseConditions';
import ResponseRedirect from './ResponseRedirect';
import NoConditionExist from './SemiComponents/NoConditionExist';
import NoRedirectExist  from './SemiComponents/NoRedirectExist';
import ConditionModal from './ConditionModal';
import RedirectModal from './RedirectModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faDirections } from '@fortawesome/free-solid-svg-icons';

class ResponseMetaInfo extends Component {

  state = {
    isControlCondition : false,
    isControlRedirect : false,
  }

  callBackCreateCondition = (response) => {
    
    const { data } = response;
    const { statusCode } = data;

    switch(statusCode) {
      case 200:
      const { createCondition } = this.props;
      const { property } = data;
      const { condition } = property;
      const { mapperID } = property;
      const { updateID } = property;

      createCondition(condition, mapperID, updateID);
      break;

      case 403:
      const { subCode } = data

      switch(subCode)  {
        case 0:
        alert("접근할 수 없는 리스폰스입니다.");
        break;

        case 1:
        alert("중복된 컨디션입니다.");
        break;

        default:
        alert("에러가 발생하였습니다.");
      }
      break;

      case 500:
      break;

      default:
    }
  }

  callBackUpdateCondition = (response) => {
    
    const { data } = response;
    const { statusCode } = data;

    switch(statusCode) {
      case 200:
      const { property } = data;
      const { condition } = property;
      const { mapperID } = property;
      const { updateID } = property;

      this.props.updateCondition(condition, mapperID, updateID);
      break;

      case 403:
      const { subCode } = data

      switch(subCode)  {
        case 0:
        alert("접근할 수 없는 리스폰스입니다.");
        break;

        case 1:
        alert("존재하지 않는 리스폰스입니다.");
        break;

        case 2:
        alert("중복된 컨디션입니다.");
        break;

        default:
        alert("에러가 발생하였습니다.");
      }
      break;

      case 500:
      break;

      default:
    }
  }

  callBackDeleteCondition = (response) => {
    
    const { data } = response;
    const { statusCode } = data;

    switch(statusCode) {
      case 200:
      const { deleteCondition } = this.props;
      const { property } = data;
      const { deletedMapperID } = property;
      const { valueDeleted } = property;

      deleteCondition(deletedMapperID, valueDeleted);
      break;

      case 403:
      const { subCode } = data

      switch(subCode)  {
        case 0:
        alert("접근할 수 없는 리스폰스입니다.");
        break;

        case 1:
        alert("존재하지 않는 리스폰스입니다.");
        break;

        default:
        alert("에러가 발생하였습니다.");
      }
      break;

      case 500:
      break;

      default:
    }
  }

  /**
   * 컨디션 컨트롤 모달 토글
   */
  toggleControlConditionModal = () => {
    this.setState({
      isControlCondition : !this.state.isControlCondition,
    })
  }
  /**
   * 리다이렉트 컨트롤 모달 토글
   */
  toggleControlRedirectModal = () => {
    this.setState({
      isControlRedirect : !this.state.isControlRedirect,
    })
  }

  /**
   * 컨디션 생성 핸들러
   */
  handleCreateCondition = (conditionText) => {
    const { responseUpdateID } = this.props;
    
    createCondition(this.callBackCreateCondition, responseUpdateID, conditionText);

    // updateCondition(this.callBackUpdateCondition, responseUpdateID, conditionText);
  }

  /**
   * 컨디션 삭제 핸들러
   */
  handleDeleteCondition = (mapperUpdateID) => {
    const { responseUpdateID } = this.props;
    
    deleteCondition(this.callBackDeleteCondition, responseUpdateID, mapperUpdateID);

    // deleteCondition(this.callBackUpdateCondition, responseUpdateID, conditionText);
  }

  /**
   * 컨디션 업데이트 핸들러
   */
  handleUpdateCondition = (mapperUpdateID, editConditionText) => {
    const { responseUpdateID } = this.props;

    updateCondition(this.callBackUpdateCondition, responseUpdateID, mapperUpdateID, editConditionText);
  }
  
  /**
   * 리스폰스 리다이렉트 updateID 업데이트
   */
  handleUpdateResponseRedirect = (requestUpdateID) => {
    
    const { updateResponseRedirect } = this.props;

    updateResponseRedirect(requestUpdateID);
    this.setState({
      isControlRedirect : false,
    })
  }

  render() {
    const { conditions } = this.props;
    
    const { redirectId } = this.props;
    const { topic } = this.props;
    const { id } = topic;

    const { toggleControlConditionModal } = this;
    const { toggleControlRedirectModal } = this;
    const { handleCreateCondition } = this;
    const { handleUpdateCondition } = this;
    const { handleDeleteCondition } = this;

    const conditionsRender = (() => {
      // if (conditions.length === 0 ) {
      //   return (<NoConditionExist toggleConditionModal={toggleControlConditionModal} />);
      // }
      // const conditionTitle = conditions[0];
      // return (
      //   <ResponseConditions 
      //     titleCondition={conditionTitle}
      //     toggleConditionModal={toggleControlConditionModal} />
      // );
      
      if (conditions) {
        if (conditions.length > 0) {
          if (conditions[0].condition) {
            const conditionTitle = conditions[0];
            return (
              <ResponseConditions 
                titleCondition={conditionTitle}
                toggleConditionModal={toggleControlConditionModal} />
            );
          }
        }
      }
      
      return (<NoConditionExist toggleConditionModal={toggleControlConditionModal} />);
    })();

    const redirectRender = (() => {
      if (redirectId) {
        
        return (
          <ResponseRedirect redirectId={redirectId}
            toggleRedirectModal={toggleControlRedirectModal} />
        );
      }
      return (
        <NoRedirectExist toggleRedirectModal={toggleControlRedirectModal} />
      );
    })();

    const conditionModalRender = (() => {
      const { isControlCondition } = this.state;
      return (
        <ConditionModal 
          show={isControlCondition}
          toggleConditionModal={toggleControlConditionModal}
          conditions={conditions}
          handleCreateCondition={handleCreateCondition}
          handleUpdateCondition={handleUpdateCondition}
          handleDeleteCondition={handleDeleteCondition} />
      );
    })();
    const redirectModalRender = (() => {
      const { isControlRedirect } = this.state;
      const { responseUpdateID } = this.props;
      const { handleUpdateResponseRedirect } = this;
      return (
        <RedirectModal 
          show={isControlRedirect}
          toggleRedirectModal={toggleControlRedirectModal}
          topicUpdateID={id}
          responseUpdateID={responseUpdateID}
          updateResponseRedirect={handleUpdateResponseRedirect}
          selectedQuestion={this.props.selectedQuestion}
          parentRequestId={this.props.parentRequestId} // 리스폰스 노드를 통해 진입했을 때 사용 (QuestionSelection이 없을 떄)
        />
      );
    })();

    return (
      <div id="ResponseMetaInfo" >
        <div class="container-fluid">
          <div class="response-meta-container">
            <div class="row">
              <div id="ResponseConditions">
                <FontAwesomeIcon icon={faSearch} className="condition-icon" />
                {conditionsRender}
              </div>
            </div>
            <div class="row">
              <div id="ResponseRedirect">
                <FontAwesomeIcon icon={faDirections} className="redirect-icon" />
                {redirectRender}
              </div>
            </div>
          </div>
        </div>
        {conditionModalRender}
        {redirectModalRender}
      </div>
    );
  }
}

export default ResponseMetaInfo;